import { UnitType } from './unit-type';

export abstract class UnitConvertible<TUnit extends UnitType> {
  protected value: number;
  protected unit: TUnit;
  protected abstract factors: Record<TUnit, number>;

  constructor(value: number, unit: TUnit) {
    this.value = value;
    this.unit = unit;
  }

  public to(unit: TUnit): number {
    if (this.unit === unit) {
      return this.value;
    }
    return this.value * (this.factors[this.unit] / this.factors[unit]);
  }

  public round(unit: TUnit, decimals = 2): number {
    return parseFloat(this.to(unit).toFixed(decimals));
  }

  public get originalValue(): number {
    return this.value;
  }

  public get originalUnit(): TUnit {
    return this.unit;
  }
}
